import React from 'react';

import Button from 'components/shared/Button/Button';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Modal from 'components/shared/Modal/Modal';

import ConsentForm from './ConsentForm';

const ConsentModal = ({
  showTechnologyModal,
  hideTechnologyModal,
  updateSurcharge,
  setPractice,
  practice
}) => {
  return (
    <Modal
      handleOpen={showTechnologyModal}
      handleClose={hideTechnologyModal}
      title="Technology Consent"
      bodyClassName="overflow-hidden"
      prevButton={
        <Button
          close
          onClick={hideTechnologyModal}
          variant="link"
          icon="arrow-left-linear"></Button>
      }>
      <ConsentForm
        hideTechnologyModal={hideTechnologyModal}
        setPractice={setPractice}
        practice={practice}
        updateSurcharge={updateSurcharge}
      />
    </Modal>
  );
};

export default withErrorBoundary(ConsentModal);
